import styled from 'styled-components';
import { deviceSizes } from '../../../../config/devices'
// export const CardContainer = styled.div`
// padding-right: 2rem;
// padding-bottom: 2rem;
// `;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding: 1.5rem;
  && {
    border-radius: 13px;
  }

  @media (max-width: ${deviceSizes.sm}) {
    flex-direction: column;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  svg {
    margin-right: 0.5rem;
    font-size: 40px;
    color: ${({ theme }) => theme && theme.grey[700]};
    /* color: ${({ theme }) => theme && theme.primary.main}; */
  }

  @media (max-width: ${deviceSizes.md}) {
    justify-content: center;
    margin-bottom: 20px;
  }
`;
